import type { RouteObject } from "react-router-dom";
import LandingPage from "../components/LandingPage/LandingPage";

// Lazy load components
// const HomePage = lazy(() => import('../pages/home/page'));
// const AdminPage = lazy(() => import('../pages/admin/page'));
// const AdminLogin = lazy(() => import('../pages/admin/login'));
// const StudentPage = lazy(() => import('../pages/student/page'));
// const StudentLogin = lazy(() => import('../pages/student/login'));
// const StudentAdmitCard = lazy(() => import('../pages/student/admit-card'));
// const ContributorPage = lazy(() => import('../pages/contributor/page'));
// const InvigilatorPage = lazy(() => import('../pages/invigilator/page'));
// const ValidatorPage = lazy(() => import('../pages/validator/page'));
// const NotFound = lazy(() => import('../pages/NotFound'));

// // Exam system components
// const ExamLogin = lazy(() => import('../pages/exam/login'));
// const FaceVerification = lazy(() => import('../pages/exam/face-verification'));
// const ExamWaiting = lazy(() => import('../pages/exam/waiting'));
// const ExamInterface = lazy(() => import('../pages/exam/interface'));

// const VerifyPage = lazy(() => import('../pages/verify/page'));
// constttttttttttttttt

const routes: RouteObject[] = [
  {
    path: "/",
    element: <LandingPage />,
  },
  // {
  //   path: '/admin',
  //   element: <AdminPage />
  // },
  // {
  //   path: '/admin/login',
  //   element: <AdminLogin />
  // },
  // {
  //   path: '/student',
  //   element: <StudentPage />
  // },
  // {
  //   path: '/student/login',
  //   element: <StudentLogin />
  // },
  // {
  //   path: '/student/admit-card',
  //   element: <StudentAdmitCard />
  // },
  // {
  //   path: '/contributor',
  //   element: <ContributorPage />
  // },
  // {
  //   path: '/invigilator',
  //   element: <InvigilatorPage />
  // },
  // {
  //   path: '/validator',
  //   element: <ValidatorPage />
  // },
  // // Exam system routes
  // {
  //   path: '/exam/login',
  //   element: <ExamLogin />
  // },
  // {
  //   path: '/exam/face-verification',
  //   element: <FaceVerification />
  // },
  // {
  //   path: '/exam/waiting',
  //   element: <ExamWaiting />
  // },
  // {
  //   path: '/exam/interface',
  //   element: <ExamInterface />
  // },
  // {
  //   path: '/verify',
  //   element: <VerifyPage />,
  // },
  // {
  //   path: '*',
  //   element: <NotFound />
  // }
];

export default routes;
